module.exports = __webpack_public_path__ + "img/station-off-white.c92e015b.png";